import { render } from "./CalendarShares.vue?vue&type=template&id=753f3559"
import script from "./CalendarShares.vue?vue&type=script&lang=js"
export * from "./CalendarShares.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__